import { Fragment, useEffect } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { getColaboradorColumns, getModelColaboradorCallCenter } from "../../../../models/ColaboradorModel";

import DeleteIcon from "@material-ui/icons/Delete";
import DetalleColaborador from "./DetalleColaborador";
import EditIcon from "@material-ui/icons/Edit";
import EliminarColaborador from "./EliminarColaborador";
import EliminarFoto from "./EliminarFoto";
import EmailIcon from "@material-ui/icons/Email";
import FormColaborador from "./FormColaborador";
import FotoColaborador from "./FotoColaborador";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import InsertPhotoIcon from "@material-ui/icons/InsertPhoto";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ReenviarCredenciales from "./ReenviarCredenciales";
import ReplayIcon from "@material-ui/icons/Replay";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { fnEmpty } from "../../../../settings/preventConfig";
import { useColaborador } from "../../../../context/ColaboradorContext";
import { useLogin } from "../../../../context/LoginContext";

export default function Colaborador() {
    const {
        listaColaboradores,
        colaboradorSeleccionado,
        handleChangeColaboradorSeleccionado,
        handleClickNuevoColaboradorCallCenter,
        handleClickNuevoColaboradorEspecialista,
        handleClickEditarColaborador,
        handleClickDetalleColaborador,
        handleClickFotoColaborador,
        handleClickReenviarCredenciales,
        handleClickEliminarColaborador,
        handleClickRefrescarDatos,
    } = useColaborador();
    const { usuarioPermisos } = useLogin();
    const permisos = usuarioPermisos["2"].Submodulos["1"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Nuevo Colaborador CallCenter
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoColaboradorCallCenter}>
                            <PersonAddIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Nuevo Colaborador Especialista
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoColaboradorEspecialista}>
                            <GroupAddIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["3"] && ( //Ver detalles de colaborador
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <IconButton onClick={handleClickDetalleColaborador}>
                            <VisibilityIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["4"] && ( //Editar datos de colaborador
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <IconButton onClick={handleClickEditarColaborador}>
                            <EditIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["5"] && ( //Foto del colaborador
                    <Tooltip title={permisos.Botones["5"].Nombre} arrow>
                        <IconButton onClick={handleClickFotoColaborador}>
                            <InsertPhotoIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["6"] && ( //Eliminar de colaborador
                    <Tooltip title={permisos.Botones["6"].Nombre} arrow>
                        <IconButton onClick={handleClickEliminarColaborador}>
                            <DeleteIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["10"] && ( //Reenviar credenciales
                    <Tooltip title={permisos.Botones["10"].Nombre} arrow>
                        <IconButton onClick={handleClickReenviarCredenciales}>
                            <EmailIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["7"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["7"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <ReplayIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <MeditocTable
                    id="iIdColaborador"
                    columns={getColaboradorColumns()}
                    data={listaColaboradores}
                    row={colaboradorSeleccionado}
                    defaultRow={getModelColaboradorCallCenter()}
                    setRow={handleChangeColaboradorSeleccionado}
                    //fnDoubleClick={permisos.Botones["3"] ? handleClickDetalleColaborador : fnEmpty}
                />
            </MeditocBody>
            <FormColaborador />
            <DetalleColaborador />
            <FotoColaborador />
            <EliminarFoto />
            <EliminarColaborador />
            <ReenviarCredenciales />
        </Fragment>
    );
}
